import {customAxios as axios} from "../../../request";
import {
    patientSaleUrl,
    patientCreditNoteUrl,
    patientDebitNoteUrl,
    patientPurchaseUrl,
    patientPaymentInUrl,
    patientPaymentOutUrl,
    singlePatientUrl, addPaymentInUrl, updateCustomerActiveStatusUrl
} from "../api/patients";
import {hideLoader, showLoader} from "../../../actions/loader";
import notification from "../../../components/Elements/Notification";

export const patientSaleFxn = async (valData) => {
    let config = {
        params: valData
    }
    let {data} = await axios.get(patientSaleUrl(), config);
    return data;
}
export const patientPurchaseFxn = async (valData) => {
    let config = {
        params: valData
    }
    let {data} = await axios.get(patientPurchaseUrl(), config);
    return data;
}
export const patientCreditNoteFxn = async (valData) => {
    let config = {
        params: valData
    }
    let {data} = await axios.get(patientCreditNoteUrl(), config);
    return data;
}
export const patientDebitNoteFxn = async (valData) => {
    let config = {
        params: valData
    }
    let {data} = await axios.get(patientDebitNoteUrl(), config);
    return data;
}
export const patientPaymentInFxn = async (valData) => {
    let config = {
        params: valData
    }
    let {data} = await axios.get(patientPaymentInUrl(), config);
    return data;
}
export const patientPaymentOutFxn = async (valData) => {
    let config = {
        params: valData
    }
    let {data} = await axios.get(patientPaymentOutUrl(), config);
    return data;
}
export const singlePatientFxn = async (valData) => {
    let {data} = await axios.post(singlePatientUrl(), valData);
    return data;
}
export const addPaymentInDirectFxn = (valData) => async (dispatch) => {
    dispatch(showLoader())
    let {data} = await axios.post(addPaymentInUrl(), valData);
    dispatch(hideLoader())
    if (!data.error) {
        notification.success({message: data.message || "Success"})
    } else {
        notification.error({message: data.message || "Error"})
    }
    return data;
}
export const updateCustomerActiveStatusFxn = (valData) => async (dispatch) => {
    dispatch(showLoader())
    let {data} = await axios.post(updateCustomerActiveStatusUrl(), valData);
    dispatch(hideLoader())
    if (!data.error) {
        notification.success({message: data.message || "Success"})
    } else {
        notification.error({message: data.message || "Error"})
    }
    return data;
}